import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

type CreateIcv = {
    icv: IcvWrite;
};

export const useCreateIcv = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (options: CreateIcv) => {
            const { icv } = options;

            const response =
                icv.id === undefined ?
                    await loggedInApiCall.post("/api/icvs", icv)
                :   await loggedInApiCall.put("/api/icvs/" + icv.id, icv);

            return response;
        },
        onSuccess: () => queryClient.invalidateQueries(["allIcvs"]),
    });

    return query;
};

export type IcvWrite = {
    id?: number;
    name: string;
    code: string;
    description?: string;
    groupName?: string;
    unitCode: string;
    climate_change: number;
    ozone_depletion: number;
    ionising_radiation: number;
    photochemical_ozone_formation: number;
    particulate_matter: number;
    human_toxicity_non_cancer: number;
    human_toxicity_cancer: number;
    acidification: number;
    eutrophication_fresh_water: number;
    eutrophication_marine: number;
    eutrophication_terrestrial: number;
    ecotoxicity_freshwater: number;
    land_use: number;
    water_use: number;
    resource_use_fossils: number;
    resource_use_minerals_metals: number;
    climate_change_fossil: number;
    climate_change_biogenic: number;
    climate_change_land_use_lu_change: number;
    human_toxicity_non_cancer_organics: number;
    human_toxicity_non_cancer_inorganics: number;
    human_toxicity_non_cancer_metals: number;
    human_toxicity_cancer_organics: number;
    human_toxicity_cancer_inorganics: number;
    human_toxicity_cancer_metals: number;
    ecotoxicity_freshwater_organics: number;
    ecotoxicity_freshwater_inorganics: number;
    ecotoxicity_freshwater_metals: number;
};
